export default "__VITE_ASSET__CnGMos8N__"